/**
 * Skeleton placeholder for the document list loading state.
 * Rendered while documents are loading and none exist yet.
 */
export default function DocumentListSkeleton() {
  return (
    <div className="bg-white dark:bg-primary-900 border border-primary-200 dark:border-primary-800 p-12 animate-pulse">
      <div className="h-6 bg-primary-100 dark:bg-primary-800 w-48 mb-4" />
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-24 bg-primary-100 dark:bg-primary-800" />
        ))}
      </div>
    </div>
  );
}
